module.exports = __webpack_public_path__ + "static/child-b-d2ceed68e722a5ac9b3fc848696079f3.jpg";